module.exports = __webpack_public_path__ + "static/media/0047.3a894cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48010/Chassis_RAL/0047.png
// module id = 413
// module chunks = 0